import { render, staticRenderFns } from "./SalesPointEditor.vue?vue&type=template&id=1cb88167&"
import script from "./SalesPointEditor.vue?vue&type=script&lang=js&"
export * from "./SalesPointEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports